/**
 * Composant de bouton de catégorie pour l'interface du quiz
 * Affiche les statistiques d'une catégorie (Histoire par défaut)
 */
import "../styles/setting.css";
import "../styles/bouton_cat.css";

/**
 * BoutonCat - Composant d'affichage de catégorie de quiz
 * @param {Object} props - Les propriétés du composant
 * @param {string} props.className - Classes CSS additionnelles pour le style
 * @param {string} props.category - Type de catégorie ('HST', 'SP', 'GEO', etc.)
 * @param {number} props.score - Score obtenu (optionnel, défaut: 0)
 * @param {number} props.nbQuestion - Nombre de questions répondues (optionnel, défaut: 0)
 * @param {function} props.onClick - Fonction appelée au clic
 * @param {boolean} props.isActive - Indique si la catégorie est sélectionnée
 * @returns {JSX.Element} Carte de catégorie avec statistiques
 */
export const BoutonCat = ({ className = '', category, score = 0, nbQuestion = 0, onClick, isActive = false }) => {
    // Configuration des catégories avec emoji et nom
    const categoryConfig = {
        HST: {
            emoji: '📖',
            nom: 'HISTOIRE'
        },
        SP: {
            emoji: '⚽',
            nom: 'SPORT'
        },
        GEO: {
            emoji: '🌍',
            nom: 'GEOGRAPHIE'
        },
        CIN: {
            emoji: '🎬',
            nom: 'CINEMA'
        },
        JV: {
            emoji: '🎮',
            nom: 'JEUX VIDEOS'
        },
        MUS: {
            emoji: '🎵',
            nom: 'MUSIQUE'
        }
    };

    const config = categoryConfig[category]

    return (
        <div 
            className={`bouton-cat ${className} ${isActive ? 'active' : ''}`} 
            data-category={category}
            onClick={onClick}
            style={{ cursor: onClick ? 'pointer' : 'default' }}
        >
            <div className="rec-cat" data-category={category}>
                <p className="rec-cat-p">{config.emoji}</p>
            </div>

            <div className="text-cat">
                <p className="text-cat-nom">{config.nom}</p>
                <div className="text-cat-inf">
                    <p className="text-cat-inf-p">Questions répondues : {nbQuestion}</p>
                    <p className="text-cat-inf-p">Meilleur score : {score} pts</p>
                </div>
            </div>
        </div>
    );
};
